import React, { useRef } from 'react'
import { useRouter } from 'next/router'

import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@wartek-id/tabs'
import { historyUtils } from '@wartek-id/toolbox-helper'

import AndroidHandler from 'utils/androidHandler'
import Header from 'app/InspirationPage/components/revamp/Header'
import PageHeader from 'app/InspirationPage/components/revamp/PageHeader'
import InspirationBlock from '../components/revamp/InspirationBlock'
import { useTogglesStore } from 'stores/toggles'
import IdePraktikHeader from 'app/InspirationPage/components/v2/IdePraktikHeader'
import PrefetchLink from 'app/InspirationPage/components/v2/PrefetchLink'
import CategoryBlockV2 from 'app/InspirationPage/components/v2/CategoryBlock'
import {
  useClickTracker,
  usePageViewTracker,
  useScrollTracker,
} from 'utils/satu-event-tracker'

const HEADER_TITLE = 'Yuk, Temukan Inspirasi Mengajar Hari Ini!'
const HEADER_SUBTITLE =
  'Praktik baik terpilih untuk membantu Bapak/Ibu menghadirkan Pembelajaran yang bermakna, berkesadaran, dan menggembirakan bagi murid'
const TRACKER_SCREEN_NAME = 'CERITA_PRAKTIK'
const TRACKER_EVENT_NAME = 'IDE_PRAKTIK_CORE_PWA_EVENT'

const InspirationRevamp = () => {
  const androidHandler = AndroidHandler()
  const router = useRouter()
  const scrollElement = useRef<HTMLDivElement>(null)
  const isIdePraktikV2Enabled = useTogglesStore(
    (state) => state.toggles?.['ide-praktik-v2-enabled']
  )

  const trackTabClick = useClickTracker({
    enabled: isIdePraktikV2Enabled,
    activityType: 'CLICK_TAB_VIDEO_INSPIRASI',
    eventName: TRACKER_EVENT_NAME,
    defaultAttributes: { screen_name: TRACKER_SCREEN_NAME },
  })

  usePageViewTracker({
    enabled: isIdePraktikV2Enabled,
    activityType: 'PAGE_VIEW_TAB_CERITA_PRAKTIK',
    eventName: TRACKER_EVENT_NAME,
    screenName: TRACKER_SCREEN_NAME,
    attributes: {
      is_webview: [androidHandler.enabled, 'bool'],
    },
  })

  useScrollTracker({
    enabled: isIdePraktikV2Enabled,
    activityType: 'SCROLL_TAB_CERITA_PRAKTIK',
    eventName: TRACKER_EVENT_NAME,
    scrollElement,
    attributes: {
      screen_name: TRACKER_SCREEN_NAME,
    },
  })

  if (isIdePraktikV2Enabled) {
    return (
      <>
        <style jsx global>
          {`
            .scrollbar-hide-auto {
              overflow-y: auto;
              scrollbar-width: thin;
              scrollbar-color: transparent transparent;
              transition: scrollbar-color 0.3s;
            }

            .scrollbar-hide-auto:hover {
              scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
            }

            /* Webkit */
            .scrollbar-hide-auto::-webkit-scrollbar {
              width: 8px;
            }

            .scrollbar-hide-auto::-webkit-scrollbar-track {
              background: transparent;
            }

            .scrollbar-hide-auto::-webkit-scrollbar-thumb {
              background: transparent;
              border-radius: 4px;
              transition: background 0.3s;
            }

            .scrollbar-hide-auto:hover::-webkit-scrollbar-thumb {
              background: rgba(0, 0, 0, 0.2);
            }

            .scrollbar-hide-auto::-webkit-scrollbar-thumb:hover {
              background: rgba(0, 0, 0, 0.4);
            }
          `}
        </style>
        <div className="bg-white flex flex-col flex-1 h-full">
          <IdePraktikHeader
            onBack={() => {
              historyUtils.backToApp(() => {
                const isNewActivity = window.history.length <= 2
                if (isNewActivity) router.push('/home')
                else router.back()
              })
            }}
            subtitle={HEADER_SUBTITLE}
            title={HEADER_TITLE}
          />
          <Tabs
            className="!flex !flex-col !flex-1 !min-h-0"
            isFitted
            withBorder
            selectedIndex={0}
            onChange={(index) => {
              if (index !== 1) return
              window.location.href = '/video-inspirasi'
            }}
          >
            <TabList
              className="flex-shrink-0"
              style={{ borderBottom: '1px solid var(--color-border-subdued)' }}
            >
              <Tab>Cerita Praktik</Tab>
              <Tab
                onClick={() => {
                  trackTabClick(undefined, { keepAlive: true })
                }}
              >
                <PrefetchLink
                  className="flex items-center justify-center w-full"
                  href="/video-inspirasi"
                >
                  Video Inspirasi
                </PrefetchLink>
              </Tab>
            </TabList>
            <TabPanels className="flex flex-col flex-1 min-h-0">
              <div
                ref={scrollElement}
                className="bg-white flex-1 overflow-y-auto scrollbar-hide-auto"
              >
                <TabPanel>
                  <CategoryBlockV2 />
                  <InspirationBlock />
                </TabPanel>
                <TabPanel>Video Inspirasi Konten</TabPanel>
              </div>
            </TabPanels>
          </Tabs>
        </div>
      </>
    )
  }

  return (
    <div>
      <PageHeader />
      <div className="min-h-full w-full absolute h-full overflow-y-scroll overflow-x-hidden pb-14 mt-14">
        <Header />
        <InspirationBlock />
      </div>
    </div>
  )
}
export default InspirationRevamp
